import CenteredContent from '@cohort/wallet/components/layout/CenteredContent';
import {LogIn} from '@cohort/wallet/components/modals/auth/LogIn';
import useStoreContext from '@cohort/wallet/hooks/useStoreContext';
import StoreLeftPanel from '@cohort/wallet/layouts/store/StoreLeftPanel';
import StorePageContainer from '@cohort/wallet/layouts/store/StorePage';
import React from 'react';
import {useTranslation} from 'react-i18next';

const StoreLoginPage: React.FC = () => {
  const {campaign} = useStoreContext();
  const {t} = useTranslation('pages', {keyPrefix: 'store.loginPage'});

  return (
    <StorePageContainer
      title={t('title')}
      tracking={{
        namespace: 'login',
      }}
      leftPanel={<StoreLeftPanel />}
    >
      <CenteredContent className="max-w-xl space-y-5 px-4 md:px-0">
        <LogIn campaign={campaign} isForBuying />
      </CenteredContent>
    </StorePageContainer>
  );
};

export default StoreLoginPage;
